import { lazyPopoutCalendarReadingPane } from 'owa-popout-calendar';
import { getUserMailboxInfo } from 'owa-client-ids';

export function displayAppointmentForm(itemId: string) {
    lazyPopoutCalendarReadingPane.importAndExecute(
        { Id: itemId, mailboxInfo: getUserMailboxInfo() },
        'CalendarAddins'
    );
}
